<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="myProvider"
      :showPagination="false"
    >
      <!-- :buttons-col-config="{ sm: 12, md: 12, lg: 12 }"
      buttons-wrapper-class="d-flex justify-content-end align-items-center" -->
      <template #buttons-filter>
        <b-row class="my-1 w-100 mx-0 pl-1">
          <b-col
            cols="12"
            class="d-flex justify-content-start align-items-center mx-0 px-0"
          >
            <b-button
              v-if="totalSeleccionados > 0"
              class="mr-1"
              variant="outline-success"
              @click="aprobarGratificacion"
            >
              <feather-icon icon="CheckCircleIcon" class="mr-1" />
              APROBAR
            </b-button>
            <b-button
              v-if="items.length > 0"
              class="mr-1"
              variant="outline-info"
              @click="generarGratificacion"
            >
              <feather-icon icon="RefreshCcwIcon" class="mr-1" />
              RECALCULAR
            </b-button>
            <!-- <b-button
          class="mr-1"
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button> -->
            <!-- <b-button
          variant="primary"
          v-b-tooltip.hover.top="'Reporte de Vacaciones'"
          @click="showReporteVacacionesModal = true"
        >
          <feather-icon icon="CalendarIcon" /> Reporte
        </b-button> -->
            <b-form-select
              v-if="periodos.length > 0"
              v-model="periodoSeleccionadoId"
              :options="periodos"
              value-field="id"
              text-field="anio_periodo"
              style="max-width: 200px"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  Seleccione ...
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
      </template>

      <template #table>
        <b-table-simple
          small
          responsive
          sticky-header="60vh"
          class="table-sticky"
        >
          <b-thead>
            <b-tr>
              <b-th rowspan="2" class="sticky-top">
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="
                    items.some((item) => item.selected) && !allSelected
                  "
                  @change="handleSelectAll"
                />
              </b-th>
              <b-th rowspan="2" class="sticky-top">Trabajador</b-th>
              <b-th rowspan="2" class="sticky-top">Estado</b-th>
              <b-th rowspan="2" class="sticky-top">Contrato</b-th>
              <b-th rowspan="2" class="sticky-top">Aplica Gratificación</b-th>
              <b-th rowspan="2" class="sticky-top">
                <span v-b-tooltip.hover.top="''">Sueldo Promedio</span>
              </b-th>
              <b-th rowspan="2" class="sticky-top">
                <span v-b-tooltip.hover.top="'Sueldo Promedio / 2'"
                  >Sueldo Computable</span
                >
              </b-th>
              <b-th rowspan="2" class="sticky-top">
                <span v-b-tooltip.hover.top="''">Meses Computables</span>
              </b-th>
              <b-th rowspan="2" class="sticky-top">
                <span v-b-tooltip.hover.top="'Meses Computables x 30'"
                  >Total Días</span
                >
              </b-th>
              <b-th colspan="7" class="text-center sticky-top"
                >Inasistencias</b-th
              >
              <b-th rowspan="2" class="sticky-top">
                <span v-b-tooltip.hover.top="'Total Días	- Total Inasistencias'"
                  >Total Días Computables</span
                >
              </b-th>
              <b-th rowspan="2" class="sticky-top">
                <span
                  v-b-tooltip.hover.top="
                    'Sueldo Computable / 180 x Total Días Computables'
                  "
                  >GRATIFICAC. A CALCULAR</span
                >
              </b-th>
              <b-th rowspan="2" class="sticky-top">
                <span v-b-tooltip.hover.top="'Gratificación a Calcular x 0.09'"
                  >BONIF. EXTRAORD. 9%</span
                >
              </b-th>
              <b-th rowspan="2" class="sticky-top">
                <span
                  v-b-tooltip.hover.top="
                    'Gratificación a Calcular + Bonificación Extraordinaria'
                  "
                  >TOTAL GRATIF. A PAGAR</span
                >
              </b-th>
              <b-th rowspan="2" class="sticky-top">
                <span>ACCIONES</span>
              </b-th>
            </b-tr>
            <b-tr>
              <b-th
                v-for="(mes, i) in ultimosMeses"
                :key="i"
                class="text-center sticky-sub"
              >
                {{ mes }}
              </b-th>
              <b-th class="text-center sticky-sub">TOTAL</b-th>
            </b-tr>
          </b-thead>

          <b-tbody v-if="items.length">
            <b-tr v-for="(item, idx) in items" :key="idx">
              <b-td class="text-center">
                <b-form-checkbox
                  v-if="item.estado === 'GENERADO'"
                  v-model="item.selected"
                  :value="true"
                  :unchecked-value="false"
                />
              </b-td>

              <!-- Trabajador -->
              <b-td>
                <router-link
                  target="_blank"
                  :class="[textLink]"
                  :to="{
                    name: 'rrhh-employees-information',
                    params: { id: item.employee_id },
                  }"
                >
                  <feather-icon
                    v-if="item.tipo_personal == 'Driver'"
                    icon="TruckIcon"
                    size="16"
                    class="text-warning"
                    v-b-tooltip.hover.top="item.employee_id"
                  />
                  <feather-icon
                    v-else
                    icon="UserIcon"
                    size="16"
                    class="text-success"
                    v-b-tooltip.hover.top="item.employee_id"
                  />
                  {{ item.empleado | capitalize }} </router-link
                ><br />
                <span style="opacity: 0.7"> {{ item.area | capitalize }} </span
                ><br />
                <span style="opacity: 0.7" class="text-primary">
                  {{ item.numero_documento | capitalize }}
                </span>
                <!-- <br />
                <span>{{ item.employee_id }}</span> -->
              </b-td>
              <!-- Estado -->
              <b-td class="text-center">
                <b-badge
                  :variant="
                    item.estado == 'GENERADO'
                      ? 'light-success'
                      : 'light-primary'
                  "
                  class="ml-1"
                >
                  {{ item.estado }}
                </b-badge>
              </b-td>
              <!-- Contrato -->
              <b-td class="text-center text-uppercase">
                {{ item.type_form }}
              </b-td>
              <!-- Aplica Gratificación -->
              <b-td class="text-center">
                <b-badge
                  v-b-tooltip.hover.top="
                    item.motivos
                      ? item.motivos.map((m) => m.mensaje).join(', ')
                      : ''
                  "
                  :variant="
                    item.aplica_gratificacion ? 'light-success' : 'light-danger'
                  "
                  class="ml-1"
                >
                  {{ item.aplica_gratificacion ? "SI" : "NO" }}
                </b-badge>
              </b-td>
              <!-- Sueldo Promedio -->
              <b-td class="text-center">
                <span class="d-block text-center"
                  >S/ {{ item.sueldo_promedio_6_meses }}</span
                >
              </b-td>
              <!-- Sueldo Computable -->
              <b-td class="text-center">
                <span class="d-block text-center"
                  >S/ {{ item.sueldo_computable }}</span
                >
              </b-td>
              <!-- Meses Computables -->
              <b-td class="text-center">
                <span class="d-block text-center">{{
                  item.meses_computables
                }}</span>
              </b-td>
              <!-- Total Días -->
              <b-td class="text-center">
                <span class="d-block text-center">{{ item.total_dias }}</span>
              </b-td>
              <!-- Inasistencias últimos 6 meses -->
              <b-td v-for="mes in ultimosMeses" :key="mes" class="text-center">
                <span :class="item.inasistencias[mes] > 0 ? 'text-danger' : ''">
                  {{ item.inasistencias[mes] }}
                </span>
              </b-td>
              <!-- Total Inasistencias -->
              <b-td class="text-center">
                <b-badge
                  :variant="
                    item.inasistencias['TOTAL'] > 0
                      ? 'light-danger'
                      : 'light-success'
                  "
                  >{{ item.inasistencias["TOTAL"] }}</b-badge
                >
              </b-td>
              <!-- Total Días Computables -->
              <b-td class="text-center">
                <span class="d-block text-center">{{
                  item.total_dias_computables
                }}</span>
              </b-td>
              <!-- Gratificación a Calcular -->
              <b-td class="text-center">
                <span class="d-block text-center text-primary"
                  >S/ {{ item.gratificacion_neta }}</span
                >
              </b-td>
              <b-td class="text-center">
                <span class="d-block text-center text-primary"
                  >S/ {{ item.gratificacion_nueve_por_ciento }}</span
                >
              </b-td>
              <b-td class="text-center">
                <span class="d-block text-center text-success"
                  >S/ {{ item.monto_a_percibir }}</span
                >
              </b-td>
              <b-td class="text-center">
                <!-- @click="viewPayroll(data.item)" -->
                <!-- <feather-icon
              v-if="data.item.status == 2 || data.item.status == 5"
              icon="EyeIcon"
              v-b-tooltip.hover.left="$t('View Payroll')"
              class="text-primary cursor-pointer ml-2"
              size="18"
            /> -->
                <!-- <feather-icon
                  v-if="data.item.status_id == 2 || data.item.status_id == 5"
                  icon="EyeIcon"
                  v-b-tooltip.hover.left="$t('View Payroll')"
                  @click="viewPayroll(data.item)"
                  class="text-primary cursor-pointer ml-2"
                  size="18"
                /> -->
                <!-- v-if="[1, 4].includes(data.item.status_id)" -->

                <feather-icon
                  icon="CheckSquareIcon"
                  v-b-tooltip.hover.left="$t('Approve')"
                  class="text-primary cursor-pointer ml-2"
                  size="18"
                  @click="openModalAprobarGratificacion(item)"
                />

                <!-- <feather-icon
                  icon="ListIcon"
                  v-b-tooltip.hover.left="$t('View Tracking')"
                  class="text-success cursor-pointer ml-2"
                  @click="openAdministrativePayrollTracking(data.item)"
                  size="18"
                /> -->
              </b-td>
            </b-tr>
          </b-tbody>

          <b-tfoot>
            <b-tr
              class="sticky-data"
              :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'"
            >
              <b-td
                v-for="(col, index) in totalColumns"
                :key="index"
                class="text-center"
              >
                <template v-if="index === 5">
                  S/. {{ sumaSueldoPromedio | currency }}
                </template>
                <template v-if="index === 6">
                  S/. {{ sumaSueldoComputable | currency }}
                </template>
                <template v-if="index === 17">
                  S/. {{ sumaGratificacionCalcular | currency }}
                </template>
                <template v-if="index === 18">
                  S/. {{ sumaBonificacionExtraordinaria | currency }}
                </template>
                <template v-if="index === 19">
                  S/. {{ sumaTotalGratificacion | currency }}
                </template>
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
      </template>
    </filter-slot>

    <ModalGenerarGratificaciones
      v-if="showModal"
      :show="showModal"
      @close="showModal = false"
      @generated="handleGenerated"
    />

    <!-- @refresh="handle" -->

    <GratificacionModal
      v-if="showAprobarGratificacionModal"
      :gratificacionData="gratificacionActual"
      @approveGrati="handleApproveGrati"
      @close="showAprobarGratificacionModal = false"
    />

    <PlanillaProcesamientoModal
      v-if="showPlanillaProcesamientoModal"
      :modalData="batchData"
      @close="handleClosePlanillaProcesamientoModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// import Filters from "@/views/rrhh/views/payroll/components/vacaciones/data/filters.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import GratificacionesService from "@/views/rrhh/views/payroll/components/gratificaciones/service/gratificaciones.service.js";
import ModalGenerarGratificaciones from "@/views/rrhh/views/payroll/components/gratificaciones/components/ModalGenerarGratificaciones.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import GratificacionModal from "@/views/rrhh/views/payroll/components/gratificaciones/components/GratificacionModal.vue";
import PlanillaProcesamientoModal from "@/views/rrhh/views/payroll/components/administrative-payroll/PlanillaProcesamientoModal.vue";

export default {
  components: {
    FilterSlot,
    ModalGenerarGratificaciones,
    GratificacionModal,
    PlanillaProcesamientoModal,
  },
  data() {
    return {
      filters: [],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showModal: false,
      items: [],
      ultimosMeses: [],
      periodos: [],
      periodoSeleccionadoId: null,
      periodoSeleccionado: null,
      allSelected: false,
      totalColumns: Array(21).fill(null), // genera un array con 20 elementos nulos
      showAprobarGratificacionModal: false,
      gratificacionActual: null,
      showPlanillaProcesamientoModal: false,
      batchData: {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      },
      progressInterval: null,
    };
  },
  watch: {
    periodoSeleccionadoId(newVal) {
      if (newVal) {
        this.periodoSeleccionado =
          this.periodos.find((p) => p.id == newVal) || null;
        this.myProvider();
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    totalSeleccionados() {
      return this.items.filter((item) => item.selected).length;
    },
    sumaSueldoPromedio() {
      return this.sumarCampo("sueldo_promedio_6_meses");
    },
    sumaSueldoComputable() {
      return this.sumarCampo("sueldo_computable");
    },
    sumaTotalGratificacion() {
      return this.sumarCampo("monto_a_percibir");
    },
    sumaBonificacionExtraordinaria() {
      return this.sumarCampo("gratificacion_nueve_por_ciento");
    },
    sumaGratificacionCalcular() {
      return this.sumarCampo("gratificacion_neta");
    },
  },
  async mounted() {
    await this.getPeriodos();
  },
  methods: {
    handleClosePlanillaProcesamientoModal() {
      this.showPlanillaProcesamientoModal = false;
      this.batchData = {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      };
    },

    refreshTable() {
      this.myProvider();
    },

    async handleApproveGrati(params) {
      this.showAprobarGratificacionModal = false;

      this.addPreloader();

      try {
        const { data } = await GratificacionesService.aprobar({
          simular: false,
          gratificaciones: [params],
        });

        const batchId = data.batch_id;

        this.showPlanillaProcesamientoModal = true;

        this.progressInterval = setInterval(async () => {
          try {
            const statusData =
              await GratificacionesService.consultarGratificacion(batchId);

            if (statusData.type === "success") {
              this.batchData = statusData.data;

              if (statusData.data.finished) {
                clearInterval(this.progressInterval);
                this.showToastSuccess("Proceso completado correctamente");
                this.refreshTable();
              }
            }
          } catch (error) {
            clearInterval(this.progressInterval);
            this.showToastError("Error consultando la gratificación");
            console.error(error);
          }
        }, 2000);
      } catch (error) {
        this.showToastError(error.response?.data);
      } finally {
        this.removePreloader();
      }
    },
    sumarCampo(campo) {
      return this.items
        .filter((item) => item.total_dias_computables >= 0)
        .reduce((total, item) => total + Number(item[campo] || 0), 0);
    },
    handleSelectAll() {
      this.items.forEach((item) => {
        if (item.estado === "GENERADO") item.selected = this.allSelected;
      });
    },
    async handleGenerated() {
      this.showModal = false;
      this.myProvider();
      await this.getPeriodos();
    },
    openModalGenerarGratificacion() {
      this.showModal = true;
    },
    openModalAprobarGratificacion(item) {
      this.gratificacionActual = item;
      this.showAprobarGratificacionModal = true;
    },
    async myProvider(ctx) {
      try {
        this.addPreloader();
        const params = {
          // page: ctx.currentPage,
          // perpage: ctx.perPage,
          // page: 1,
          perpage: 100,
          search_txt: this.filterPrincipal.model,
          periodo_id: this.periodoSeleccionadoId,
          // start_date_from: this.filters[0].model,
          // start_date_to: this.filters[1].model,
          // area_id: this.filters[2].model,
        };
        const { data } = await GratificacionesService.index(params);

        let paginacion = data.data;

        // loop paginacion data and set items selected = false
        for (let i = 0; i < paginacion.data.length; i++) {
          paginacion.data[i].selected = false;
        }

        this.ultimosMeses = data.ultimosMeses;
        this.items = paginacion.data;
        this.paginate.from = paginacion.from;
        this.paginate.to = paginacion.to;
        this.paginate.of = paginacion.total;
        this.paginate.perPage = paginacion.per_page;
        this.paginate.currentPage = paginacion.current_page;
        // return data.data || [];
      } catch (error) {
        this.showToastError(
          error.response?.data || error.message || "Error al cargar datos"
        );
      } finally {
        this.removePreloader();
      }
    },

    async getPeriodos() {
      try {
        const { data } = await GratificacionesService.getPeriodos();
        this.periodos = data || [];
        if (this.periodos.length > 0) {
          this.periodoSeleccionadoId = this.periodos[0].id;
        } else {
          this.periodoSeleccionadoId = null;
          this.periodoSeleccionado = null;
        }
      } catch (error) {
        console.log(error);
        this.periodos = [];
        this.periodoSeleccionadoId = null;
        this.periodoSeleccionado = null;
      }
    },

    async generarGratificacion() {
      try {
        this.addPreloader();

        const { data } = await GratificacionesService.generar({
          periodo: this.periodoSeleccionado.periodo,
          anio: this.periodoSeleccionado.anio,
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: data.message,
            icon: "CheckCircleIcon",
            variant: "success",
            text: data.message,
          },
        });

        this.myProvider();
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: error?.response?.data || error.message || error,
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    // async aprobarGratificacion() {
    //   try {
    //     this.addPreloader();

    //     const empleadosSeleccionados = this.items
    //       .filter((item) => item.selected)
    //       .map((item) => item.employee_id);

    //     const { data } = await GratificacionesService.aprobar({
    //       periodo: this.periodoSeleccionado.periodo,
    //       anio: this.periodoSeleccionado.anio,
    //       empleados: empleadosSeleccionados,
    //     });

    //     this.$toast({
    //       component: ToastificationContent,
    //       position: "top-right",
    //       props: {
    //         title: data.message,
    //         icon: "CheckCircleIcon",
    //         variant: "success",
    //         text: data.message,
    //       },
    //     });

    //     this.myProvider();
    //   } catch (error) {
    //     console.log(error);
    //     this.$toast({
    //       component: ToastificationContent,
    //       position: "top-right",
    //       props: {
    //         title: "Error",
    //         icon: "XCircleIcon",
    //         variant: "danger",
    //         text: error?.response?.data || error.message || error,
    //       },
    //     });
    //   } finally {
    //     this.removePreloader();
    //   }
    // },

    // async exportToExcel(ctx) {
    //   try {
    //     this.addPreloader();
    //     const params = {
    //       page: ctx.currentPage,
    //       perpage: ctx.perPage,
    //       search_txt: this.filterPrincipal.model,
    //       start_date_from: this.filters[0].model,
    //       start_date_to: this.filters[1].model,
    //       area_id: this.filters[2].model,
    //     };

    //     const response = await VacacionesService.exportToExcel(params);

    //     // Extraer nombre de archivo desde el header Content-Disposition
    //     const disposition = response.headers["content-disposition"];
    //     let filename = "vacaciones.xlsx";
    //     if (disposition && disposition.includes("filename=")) {
    //       filename = disposition
    //         .split("filename=")[1]
    //         .replace(/['"]/g, "") // eliminar comillas si hay
    //         .trim();
    //     }

    //     this.forceFileDownload(response.data, filename);
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.removePreloader();
    //   }
    // },
    // async getAreas() {
    //   try {
    //     const { data } = await EmployeeService.getAllAreas({
    //       moduleId: this.currentUser.modul_id,
    //     });
    //     this.filters[2].options = data;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>

<style>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}
.k-state-hover .k-state-focused {
  background-color: transparent !important;
  border-color: transparent !important;
}
.k-widget.form-control .k-input {
  height: 2.5rem !important;
}
</style>

<style>
.table-sticky th {
  vertical-align: middle !important; /* centra el texto verticalmente */
  text-align: center !important; /* centra horizontalmente */
  z-index: 2 !important;
}

/* Primera fila sticky (encabezados principales) */
.table-sticky th.sticky-top {
  position: sticky !important;
  top: 0 !important;
  z-index: 3 !important;
}

/* Segunda fila sticky (subcolumnas de Inasistencias) */
.table-sticky th.sticky-sub {
  position: sticky !important;
  top: 26.165px !important; /* Ajusta este valor según la altura de la primera fila */
  z-index: 2 !important;
}

.sticky-data {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}
</style>
